import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { Form, TextArea } from "semantic-ui-react";
import TextParagraph from "../../../../../components/ui/TextParagraph";

const TextBlock = props => (
  <div>
    {props.isReadOnlyMode ? (
      /**
       * Renders a text paragraph with corrected line breaks
       */
      <TextParagraph content={props.block[props.dataKey]} />
    ) : (
      <Form>
        <TextArea
          value={props.block[props.dataKey]}
          disabled={props.isReadOnlyMode}
          autoHeight
          onChange={(_, { value }) => {
            /**
             * Performs a copy of the block and updates
             * its text
             */
            const block = { ...props.block };
            block[props.dataKey] = value;

            /**
             * Passes on the block update to the higher-order
             * component
             */
            props.onChange(block);
          }}
          placeholder={props.intl.formatMessage({
            id: props.placeholder
          })}
        />
      </Form>
    )}
  </div>
);

TextBlock.propTypes = {
  /**
   * block: {text}
   * Contains the content block information
   */
  block: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,

  /**
   * isReadOnlyMode: Boolean
   * True if the block is read-only
   */
  isReadOnlyMode: PropTypes.bool.isRequired,

  /**
   * onChange: updatedBlock => ()
   * Passes on a block update to the higher-level component
   */
  onChange: PropTypes.func.isRequired,

  /**
   * placeholder: String
   * Text that is displayed in edit-mode as a placeholder.
   * (Default text is defined by manuscript.blocks.text.placeholder)
   */
  placeholder: PropTypes.string,

  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired,

  /**
   * dataKey: String
   * Key, under which the entered text is stored within the block
   */
  dataKey: PropTypes.string
};

TextBlock.defaultProps = {
  placeholder: "manuscript.blocks.text.placeholder",
  dataKey: "text"
};

export default injectIntl(TextBlock);



// WEBPACK FOOTER //
// ./src/modules/editor/manuscript/blocks/text/TextBlock.js